import styled, { css } from 'styled-components';
import { space } from 'styled-system';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { border, spacing, zIndex, themeMode, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';

const TRANSITION_DURATION = 300;
const getDrawerPosition = (side = "bottom") => {
  const horizontalSizes = css`
        width: 80vw;
        height: 100%;
    `;
  const verticalSizes = css`
        max-height: 80vh;
        width: 100%;
        max-width: 100%;
    `;
  return {
    top: css`
            top: 0;
            bottom: auto;
            left: 0;
            ${verticalSizes};
        `,
    bottom: css`
            top: auto;
            bottom: 0;
            left: 0;
            ${verticalSizes};
        `,
    left: css`
            top: 0;
            left: 0;
            ${horizontalSizes};
        `,
    right: css`
            top: 0;
            right: 0;
            ${horizontalSizes};
        `
  }[side];
};
const Header = styled(Box)`
    flex: 0 0 auto;

    border-bottom: ${border("base")};
    padding: ${spacing("lg")} ${spacing("xl")};

    ${({ theme }) => theme.breakpoint("md")`
            padding: ${spacing("sm")} ${spacing("md")};
        `}
`;
const Footer = styled(Box)`
    flex: 0 0 auto;
    margin-top: auto;

    border-top: ${border("base")};
    padding: ${spacing("lg")} ${spacing("xl")};

    ${({ theme }) => theme.breakpoint("md")`
            padding: ${spacing("sm")} ${spacing("md")};
        `}
`;
const Content = styled(Box)`
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;

    padding: ${spacing("lg")} ${spacing("xl")};

    ${({ theme }) => theme.breakpoint("md")`
            padding: ${spacing("sm")} ${spacing("md")};
        `}

    ${space};
`;
const Drawer = styled(Box)`
    z-index: ${zIndex("modal")};
    position: fixed;
    overflow: hidden;
    pointer-events: auto;
    display: flex;
    flex-direction: column;

    max-width: 100%;
    max-height: 100%;

    ${({ side, isFull }) => isFull ? css`
                  top: 0;
                  right: 0;
                  bottom: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
              ` : getDrawerPosition(side)};

    background: ${themeMode({ light: palette("neutral.0"), dark: palette("neutral.900") })};
    color: ${themeMode({ light: palette("neutral.900"), dark: palette("neutral.0") })};
`;

export { Content, Drawer, Footer, Header, TRANSITION_DURATION, getDrawerPosition };
//# sourceMappingURL=styled.es.js.map
